export default __webpack_public_path__ + "static/media/AboutUs_BG-01.d0575848.png";